export const ALLOWED_KEYS = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight']
export const DEFAULT_INPUT_SIZE = 2

export const EMPTY_DISPLAY = {
  SYMBOL: 'symbol',
  ZERO: 'zero',
} as const

export const VARIANT = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const
